export enum ReportType {
  FbaInventoryReport = 'FbaInventoryReport',
  FbmReport = 'FbmReport',
  InventoryHealthReport = 'InventoryHealthReport',
  RestockReport = 'RestockReport',
  FbaFeesReport = 'FbaFeesReport',
  AvgPrice7daysReport = 'AvgPrice7daysReport',
  AllOrdersDataReport = 'AllOrdersDataReport'
}
